let modules = {}
const moduleList = require.context('@/api', false, /\.js$/)
moduleList.keys().forEach(fileName => {
  const moduleName = fileName.substring(2, fileName.length - 3)
  modules[moduleName] = moduleList(fileName)
})

export default modules
